import React from 'react';
import PropTypes from 'prop-types';

/**
 * Outlet logo/image component
 * Displays 32px circular image if available, otherwise shows placeholder icon
 *
 * @param {Object} props
 * @param {string} props.imageUrl - URL to outlet logo image
 * @param {string} props.name - Outlet name for alt text
 * @returns {React.ReactElement} Image or placeholder icon
 */
function OutletLogo({ imageUrl = null, name }) {
  if (imageUrl) {
    return (
      <img
        src={imageUrl}
        alt={name}
        style={{
          width: '32px',
          height: '32px',
          borderRadius: '50%',
          objectFit: 'cover',
          marginRight: '0.5rem',
        }}
        loading="lazy"
      />
    );
  }

  return (
    <i
      className="fa fa-newspaper"
      style={{
        width: '32px',
        height: '32px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        marginRight: '0.5rem',
        color: '#999',
      }}
    />
  );
}

OutletLogo.propTypes = {
  imageUrl: PropTypes.string,
  name: PropTypes.string.isRequired,
};

OutletLogo.defaultProps = {
  imageUrl: null,
};

export default OutletLogo;
